


























import { Component, Vue, Prop } from "vue-property-decorator";
import CModal from "@/basics/modal/CModal.vue";
import TextInput from "@/basics/inputs/TextInput.vue";
import CButton from "@/basics/buttons/CButton.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";

export type Status = "saving" | "saved" | "error" | "default";

@Component<EditTextModal>({
  components: { CModal, TextInput, CButton, ModalTitle },
  watch: {
    show() {
      this.reset();
    }
  }
})
export default class EditTextModal extends Vue {
  @Prop({ type: String, required: false, default: "値" })
  name!: string;
  @Prop({ type: Boolean, required: false, default: true }) show!: boolean;
  @Prop({ type: String, required: false, default: "" }) value!: string;
  @Prop({
    type: String,
    required: false,
    default: "default"
  })
  status!: Status;
  @Prop({ type: String, required: false, default: "" }) info!: string;

  editingValue = "";

  reset() {
    this.status = "default";
    this.editingValue = this.value;
  }

  close() {
    if (this.status === "saving") {
      return;
    }
    if (this.show) {
      this.$emit("close", { status: this.status });
    }
  }

  save() {
    this.$emit("save", this.editingValue);
  }
}
